"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referrerMapper = void 0;
var referrerMapper = function (referrerId, linkName, eventType) {
  if (eventType === void 0) {
    eventType = 'click';
  }
  return {
    schemaName: 'referrer',
    messageContent: {
      referrerId: referrerId,
      linkName: linkName,
      eventType: eventType
    }
  };
};
exports.referrerMapper = referrerMapper;